export default __webpack_public_path__ + "static/media/ag-icon.74fd7667.svg";